/** Prospect éligible à la campagne : possède tous les tags de la campagne (règle emailing CRM). */
export function prospectMatchesCampaign(prospectTags, campaignTags) {
  const tags = Array.isArray(campaignTags) ? campaignTags.filter(Boolean) : [];
  if (tags.length === 0) return false;
  const set = new Set(Array.isArray(prospectTags) ? prospectTags : []);
  return tags.every((t) => set.has(t));
}

export function campaignIdsForProspect(prospectTags, campaigns) {
  if (!Array.isArray(campaigns)) return [];
  return campaigns
    .filter((c) => prospectMatchesCampaign(prospectTags, c.tags))
    .map((c) => c.id);
}

export function mergeProspectTagsWithCampaigns(tagNames, campaignIds, campaigns) {
  const manual = Array.isArray(tagNames)
    ? tagNames.map((t) => String(t).trim()).filter(Boolean)
    : [];
  const fromCampaigns = (Array.isArray(campaigns) ? campaigns : [])
    .filter((c) => (campaignIds || []).includes(c.id))
    .flatMap((c) => (Array.isArray(c.tags) ? c.tags : []));
  return [...new Set([...manual, ...fromCampaigns])];
}

export function campaignsForProspect(prospectTags, campaigns) {
  if (!Array.isArray(campaigns)) return [];
  return campaigns.filter((c) => prospectMatchesCampaign(prospectTags, c.tags));
}
